import color01 from "./mosaic/01.jpg";
import color02 from "./mosaic/02.jpg";
import color03 from "./mosaic/03.jpg";
import color04 from "./mosaic/04.jpg";
import color05 from "./mosaic/05.jpg";
import color06 from "./mosaic/06.jpg";
import color07 from "./mosaic/07.jpg";
import color08 from "./mosaic/08.jpg";
import color09 from "./mosaic/09.jpg";
import color10 from "./mosaic/10.jpg";
import color11 from "./mosaic/11.jpg";
import color12 from "./mosaic/12.jpg";
import color13 from "./mosaic/13.jpg";
import color14 from "./mosaic/14.jpg";
import color15 from "./mosaic/15.jpg";
import color16 from "./mosaic/16.jpg";
import color17 from "./mosaic/17.jpg";

import combineBack1 from "../assets/mosaic/masks/1.png";
import combineBack2 from "../assets/mosaic/masks/2.png";
import combineBack3 from "../assets/mosaic/masks/3.png";
import combineBack4 from "../assets/mosaic/masks/4.png";

export const mosaicApi = [
  {
    id: 1,
    code: "фіолетовий",
    img: color01,
    rgb: "rgb(126, 112, 161)",
    hex: "#7e70a1",
  },
  {
    id: 2,
    code: "темно-зелений",
    img: color02,
    rgb: "rgb(79, 115, 71)",
    hex: "#4f7347",
  },
  {
    id: 3,
    code: "світло-зелений",
    img: color03,
    rgb: "rgb(188, 208, 171)",
    hex: "#bcd0ab",
  },
  {
    id: 4,
    code: "синій",
    img: color04,
    rgb: "rgb(57, 77, 134)",
    hex: "#394d86",
  },
  {
    id: 5,
    code: "сірий",
    img: color05,
    rgb: "rgb(157, 157, 159)",
    hex: "#9d9d9f",
  },
  {
    id: 6,
    code: "білий",
    img: color06,
    rgb: "rgb(240, 239, 234)",
    hex: "#f0efea",
  },
  {
    id: 7,
    code: "чорний",
    img: color07,
    rgb: "rgb(65, 66, 67)",
    hex: "#414243",
  },
  {
    id: 8,
    code: "бордо",
    img: color08,
    rgb: "rgb(112, 29, 35)",
    hex: "#701d23",
  },
  {
    id: 9,
    code: "світло-коричневий",
    img: color09,
    rgb: "rgb(152, 20, 12)",
    hex: "#98140c",
  },
  {
    id: 10,
    code: "помаранчевий",
    img: color10,
    rgb: "rgb(236, 122, 681)",
    hex: "#ec7a44",
  },
  {
    id: 11,
    code: "коричневий",
    img: color11,
    rgb: "rgb(116, 84, 67)",
    hex: "#745443",
  },
  {
    id: 12,
    code: "темно-коричневий",
    img: color12,
    rgb: "rgb(85, 72, 70)",
    hex: "#554846",
  },
  {
    id: 13,
    code: "срібло",
    img: color13,
    rgb: "rgb(140, 140, 136)",
    hex: "#8c8c88",
  },
  {
    id: 14,
    code: "золото",
    img: color14,
    rgb: "rgb(208, 164, 60)",
    hex: "#d0a43c",
  },
  {
    id: 15,
    code: "бежевий",
    img: color15,
    rgb: "rgb(205, 177, 135)",
    hex: "#cdb187",
  },
  {
    id: 16,
    code: "темно-сірий",
    img: color16,
    rgb: "rgb(102, 106, 107)",
    hex: "#666a6b",
  },
  {
    id: 17,
    code: "червоно-коричневий",
    img: color17,
    rgb: "rgb(103, 71, 68)",
    hex: "#674744",
  },
];

export const defaultCombine = [
  {
    id: 1,
    color: {
      id: "",
      code: "",
      img: "",
    },
    mask: combineBack1,
  },
  {
    id: 2,
    color: {
      id: "",
      code: "",
      img: "",
    },
    mask: combineBack2,
  },
  {
    id: 3,
    color: {
      id: "",
      code: "",
      img: "",
    },
    mask: combineBack3,
  },
  {
    id: 4,
    color: {
      id: "",
      code: "",
      img: "",
    },
    mask: combineBack4,
  },
];
